let v6042;
const vA317 = [0, 26, 44, 70, 100, 134, 172, 196, 242, 292, 346, 404, 466, 532, 581, 655, 733, 815, 901, 991, 1085, 1156, 1258, 1364, 1474, 1588, 1706, 1828, 1921, 2051, 2185, 2323, 2465, 2611, 2761, 2876, 3034, 3196, 3362, 3532, 3706];
exports.getSymbolSize = function (p7183) {
  if (!p7183) {
    throw new Error("\"version\" cannot be null or undefined");
  }
  if (p7183 < 1 || p7183 > 40) {
    throw new Error("\"version\" should be in range from 1 to 40");
  }
  return p7183 * 4 + 17;
};
exports.getSymbolTotalCodewords = function (p7184) {
  return vA317[p7184];
};
exports.getBCHDigit = function (p7185) {
  let vLN0963 = 0;
  while (p7185 !== 0) {
    vLN0963++;
    p7185 >>>= 1;
  }
  return vLN0963;
};
exports.setToSJISFunction = function (p7186) {
  if (typeof p7186 != "function") {
    throw new Error("\"toSJISFunc\" is not a valid function.");
  }
  v6042 = p7186;
};
exports.isKanjiModeEnabled = function () {
  return typeof v6042 != "undefined";
};
exports.toSJIS = function (p7187) {
  return v6042(p7187);
};